import React, { Component } from 'react'
import FooterStructure from '../../../structures/footer/index'

export class Footer extends Component {
  constructor(props) {
    super(props)
    this.id = 'footer'
    this.type = 'footer'
  }

  static defaultProps = {
    id: 'footer',
    preset: 1, // 预设
    meta: {}, // 站点 meta 数据
  }

  render() {
    const structure = new FooterStructure(this.props)
    return (
      <div className="site-footer">
        { structure.current() }
      </div>
    )
  }
}

export default Footer


// WEBPACK FOOTER //
// ./app/javascript/app/site/components/site_layout/footer/index.js